import Compressor from "compressorjs"

export async function urlToBlob(url: string): Promise<Blob> {
  const response = await fetch(url)
  return response.blob()
}

export async function urlToFile(dataUrl: string, fileName: string): Promise<File> {
  const blob = await urlToBlob(dataUrl)
  return blobToFile(blob, fileName)
}

export function blobToFile(theBlob: Blob, fileName: string): File {
  return new File([theBlob], fileName, { lastModified: new Date().getTime(), type: theBlob.type })
}

export async function blobToArrayBuffer(blob: Blob): Promise<ArrayBuffer> {
  // old safari has problems with blob.arrayBuffer() - https://caniuse.com/mdn-api_blob_arraybuffer
  if (blob.arrayBuffer) {
    return await blob.arrayBuffer()
  }

  return await new Response(blob).arrayBuffer()
}

export function getFileDimensions(file: File) {
  const dataUrl = window.URL.createObjectURL(file)
  const cleanup = () => window.URL.revokeObjectURL(dataUrl)

  return new Promise<{ height: number; width: number }>((resolve, reject) => {
    const img = new Image()

    img.onload = () => {
      cleanup()
      resolve({
        height: img.height,
        width: img.width,
      })
    }

    img.onerror = (e) => {
      cleanup()
      reject(e)
    }

    img.src = dataUrl
  })
}

interface CompressedFile {
  file: File
  originalWidth: number
  originalHeight: number
}

function compressFile(file: File, options?: Compressor.Options) {
  let originalWidth = 0
  let originalHeight = 0

  return new Promise<CompressedFile>((resolve, reject) => {
    new Compressor(file, {
      ...options,
      success: (result) => {
        // NOTE: Blob je tu v typu pravděpodobně jenom kvůli tomu, že Compressor dokáže optimalizovat i Blob
        const file = result instanceof File ? result : blobToFile(result, "name.jpeg")
        resolve({ file, originalWidth, originalHeight })
      },
      drew: (context, canvas) => {
        originalWidth = canvas.width
        originalHeight = canvas.height
      },
      error: reject,
    })
  })
}

export function optimizeFile(file: File, mimeType = "image/jpeg") {
  const max = 3000
  return compressFile(file, { maxHeight: max, maxWidth: max, quality: 0.9, mimeType, retainExif: true })
}

export function imgFromUrl(url: string) {
  return new Promise<HTMLImageElement>((resolve, reject) => {
    const imageToLoad = new window.Image()

    imageToLoad.crossOrigin = "anonymous"
    imageToLoad.src = url

    function loadCallback() {
      imageToLoad.removeEventListener("load", loadCallback)
      imageToLoad.removeEventListener("error", errorCallback)
      resolve(imageToLoad)
    }

    function errorCallback(e: ErrorEvent) {
      imageToLoad.removeEventListener("load", loadCallback)
      imageToLoad.removeEventListener("error", errorCallback)
      reject(e)
    }

    imageToLoad.addEventListener("load", loadCallback)
    imageToLoad.addEventListener("error", errorCallback)
  })
}
